import React, {useEffect} from "react";
import {SideBar} from "./sideBar";
import {useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";

export const Menu: React.FC = () => {
    const {t} = useTranslation();
    const [displayMenu, setDisplayMenu] = React.useState<boolean>(false);
    const location = useLocation();

    // close the side when the url change (when the user click on a button)
    useEffect(() => {
        setDisplayMenu(false);
    }, [location]);

    return (
        <>
            {/* desktop */}
            <div className="hidden md:flex">
                <SideBar/>
            </div>

            {/* mobile */}
            <div
                className="flex absolute md:hidden p-4 cursor-pointer z-30"
                onClick={() => setDisplayMenu(!displayMenu)}
            >
                <img
                    className="h-6"
                    src={`/icons/${displayMenu ? "close": "burger-menu"}.svg`}
                    alt={t("global.menu-icon")}
                />
            </div>

            <div className={`flex absolute w-screen h-screen z-10 transition-all duration-300 ${displayMenu ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
                <div className={`h-full z-20 bg-darkblue transition-transform duration-300 ease-out ${displayMenu ? 'translate-x-0' : '-translate-x-full'}`}>
                    <SideBar marginTop={true} />
                </div>

                <div
                    className="h-full w-full fixed bg-transparent-very-black backdrop-blur-sm"
                    onClick={() => setDisplayMenu(false)}
                />
            </div>
        </>
    )
}
